import Header from '@packages/shared/core/common/components/layout/Header';
import { SingleAnswerScreenProps } from '@packages/shared/core/quiz/entities';
import Image from '@packages/shared/core/common/components/common/Image';
import Banner from '@packages/shared/simple-simple-registration/components/Banner';
import ProgressBar from '@packages/shared/simple-simple-registration/components/ProgressBar';
import ButtonBack from '@packages/shared/core/common/components/common/ButtonBack';
import { prepareHtml } from '@packages/shared/core/common/utils/prepareHtml';
import { LocationCountryCase, LocationCountrySwitch } from '@packages/shared/core/location/ui';
import { LocationCountry } from '@packages/shared/core/location/entities';
import styles from './SingleAnswerScreen.module.scss';

const SingleAnswerScreen = ({
  content,
  onChosen,
  index: activeStep,
  totalSteps,
  onBack,
}: SingleAnswerScreenProps) => {
  return (
    <>
      <div className={styles.background} />

      <Banner />

      <Header className={styles.header} menuClassName={styles.menu}>
        <ButtonBack className={styles.buttonBack} secondary onClick={onBack} />
      </Header>

      <div className={styles.container}>
        <ProgressBar
          className={styles.progressBar}
          title={content.progressTitle}
          steps={totalSteps}
          activeStep={activeStep}
        />

        <h2 className={styles.title}>{content.title}</h2>

        <h3 className={styles.subtitle}>{content.subtitle}</h3>

        <ul className={styles.list}>
          {content.answers.map(({ text, emoji, value }) => (
            <li
              role="button"
              onClick={() => onChosen(text, value)}
              key={text}
              className={styles.listItemWrapper}
            >
              <div className={styles.listItem}>
                {emoji && (
                  <Image
                    className={styles.icon}
                    type="future"
                    src={emoji}
                    alt={text}
                    width={56}
                    height={56}
                  />
                )}

                <p className={styles.text}>{text}</p>
              </div>
            </li>
          ))}
        </ul>

        <LocationCountrySwitch>
          <LocationCountryCase value={LocationCountry.US}>
            {content.disclaimer && (
              <p
                className={styles.disclaimer}
                dangerouslySetInnerHTML={prepareHtml(content.disclaimer)}
              />
            )}
          </LocationCountryCase>
        </LocationCountrySwitch>
      </div>
    </>
  );
};

export default SingleAnswerScreen;
